import debug from 'debug';
import DictionaryObject from 'Global/Shared/Components/Sitecore/DictionaryObject';

import lukSolidSvg from 'Minetilbud/Shared/Icons/luk_solid.svg';
import preferencesSolidSvg from 'Minetilbud/Shared/Icons/icon_preferences_solid.svg';

const log = debug('FrontPageCatalogs:Templates:CategoryFilterTemplates');

class CategoryFilterTemplates {

	constructor() {
		this.dictionary = new DictionaryObject({
			dictionaryUrl: 'Forum_dk/AdvertUI/MtCustomerCatalogs',
			includeDescendants: false
		});
	}

	base() {
		return `
			<div class="o-front-page-catalogs-category-filter__wrapper" data-ref="catalogs-filter__wrapper">
				${this.headline()}
				<section class="o-front-page-catalogs-category-filter__container" data-ref="catalogs-filter__container">
					<h4 class="o-front-page-catalogs-category-filter__title">Kategorier</h4>
					<ul class="o-front-page-catalogs-category-filter__option-list" data-ref="catalogs-filter__categories"></ul>
				</section>
			</div>
		`;
	}

	/**
	 * @param {number} [count]
	 */
	 catalogsCount(count) {
		if (count === undefined) return '';
		return `<span class="o-front-page-catalogs-category-filter__catalogs-count">(${count})</span>`;
	}

	/**
	 * 
	 * @param {Object} category 
	 * @param {string} category.id
	 * @param {string} category.name
	 * @param {number} [category.count]
	 * @param {boolean} [category.isSelected]
	 */
	category(category) {
		return `
			<li class="o-front-page-catalogs-category-filter__option">
				<a class="o-front-page-catalogs-category-filter__option-link ${category.isSelected ? 'is-selected' : ''}" 
					href="#top" data-id="${category.id}"  data-js="catalogs-filter-category">
					<span class="o-front-page-catalogs-category-filter__option-toggle"></span>
					${category.name}
					${this.catalogsCount(category.count)}
				</a>
			</li>
		`;
	}

	categoryAll(isSelected) {
		return this.category({
			id: 'alle',
			name: this.dictionary.Text('allCategoriesLabelNew'),
			isSelected
		});
	}

	dictionaryInit() {
		return this.dictionary.Get();
	}

	headline() {
		return `
			<h3 class="o-front-page-catalogs-category-filter__headline">
				<span class="o-front-page-catalogs-category-filter__headline-open" data-ref="catalogs-filter__open">${preferencesSolidSvg}</span>
				<span class="o-front-page-catalogs-category-filter__headline-close" data-ref="catalogs-filter__close">${lukSolidSvg}</span>
				<span class="o-front-page-catalogs-category-filter__headline-text">${this.dictionary.Text('filterHeadline')}</span>
			</h3>
		`;
	}

	toggle() {
		return `
			<a class="o-front-page-catalogs-category-filter__toggle" data-ref="catalogs-filter__toggle" href="#01" title="Vis/skjul filtre">
				<span class="o-front-page-catalogs-category-filter__toggle-open">${preferencesSolidSvg}</span>
				<span class="o-front-page-catalogs-category-filter__toggle-close">${lukSolidSvg}</span>
			</a>
		`;
	}

}

export default CategoryFilterTemplates;
